module.exports = __webpack_public_path__ + "static/media/login_empresa.85b50223.jpg";